import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { chicaService, convertirChicaDTO, distritosMapping, tiposMapping } from '../services/api';
import { tipos } from '../data/chicasData';
import '../App.css';

function CatalogoPage() {
  const { tipo } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const distritoParam = searchParams.get('distrito');
  
  const [filtros, setFiltros] = useState({
    tipo: tipo || 'todos',
    distrito: distritoParam || 'Todos',
    edadMin: 18,
    edadMax: 35
  });

  const [chicasFiltradas, setChicasFiltradas] = useState([]);
  const [todasLasChicas, setTodasLasChicas] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Cargar todas las chicas al montar el componente
  useEffect(() => {
    cargarChicas();
  }, []);

  // Actualizar filtros cuando cambian los parámetros de la URL
  useEffect(() => {
    if (tipo && filtros.tipo !== tipo) {
      setFiltros(prev => ({ ...prev, tipo }));
    }
    if (distritoParam && filtros.distrito !== distritoParam) {
      setFiltros(prev => ({ ...prev, distrito: distritoParam }));
    }
  }, [tipo, distritoParam]);

  // Aplicar filtros cuando cambian
  useEffect(() => {
    aplicarFiltros();
  }, [filtros, todasLasChicas]);

  const cargarChicas = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const chicasDTO = await chicaService.obtenerTodas();
      const chicasConvertidas = chicasDTO.map(convertirChicaDTO);
      
      // Agregar imágenes manualmente (puedes tener un array de imágenes)
      const imagenesDisponibles = [
        "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400&h=600&fit=crop",
        "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=600&fit=crop",
        "https://images.unsplash.com/photo-1529626455594-4ff0802cfb7e?w=400&h=600&fit=crop",
        "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=400&h=600&fit=crop",
        "https://images.unsplash.com/photo-1488426862026-3ee34a7d66df?w=400&h=600&fit=crop",
        "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=400&h=600&fit=crop",
        "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&h=600&fit=crop",
        "https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=400&h=600&fit=crop",
        "https://images.unsplash.com/photo-1509967419530-da38b4704bc6?w=400&h=600&fit=crop",
        "https://images.unsplash.com/photo-1502823403499-6ccfcf4fb453?w=400&h=600&fit=crop",
        "https://images.unsplash.com/photo-1506748686214-e9df14d4d9d0?w=400&h=600&fit=crop",
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=600&fit=crop",
        "https://images.unsplash.com/photo-1513956589380-bad6acb9b9d4?w=400&h=600&fit=crop",
        "https://images.unsplash.com/photo-1515191107209-c28698631303?w=400&h=600&fit=crop",
        "https://images.unsplash.com/photo-1516575150278-77136aed6920?w=400&h=600&fit=crop",
      ];

      const chicasConImagenes = chicasConvertidas.map((chica, index) => ({
        ...chica,
        imagen: imagenesDisponibles[index % imagenesDisponibles.length]
      }));

      setTodasLasChicas(chicasConImagenes);
    } catch (err) {
      console.error('Error al cargar chicas:', err);
      setError('Error al cargar las chicas. Por favor, intenta más tarde.');
    } finally {
      setLoading(false);
    }
  };

  const aplicarFiltros = () => {
    let resultado = [...todasLasChicas];

    // Filtrar por tipo
    if (filtros.tipo !== 'todos') {
      resultado = resultado.filter(chica => 
        chica.tipos && chica.tipos.includes(filtros.tipo)
      );
    }

    // Filtrar por distrito
    if (filtros.distrito !== 'Todos') {
      resultado = resultado.filter(chica => 
        chica.distrito === filtros.distrito || 
        (chica.distritosDisponibles && chica.distritosDisponibles.includes(filtros.distrito))
      );
    }

    // Filtrar por edad
    resultado = resultado.filter(chica => 
      chica.edad >= filtros.edadMin && chica.edad <= filtros.edadMax
    );

    setChicasFiltradas(resultado);
  };

  const handleFiltroChange = (campo, valor) => {
    setFiltros(prev => ({
      ...prev,
      [campo]: valor
    }));
  };

  const resetFiltros = () => {
    setFiltros({
      tipo: 'todos',
      distrito: 'Todos',
      edadMin: 18,
      edadMax: 35
    });
  };

  const tipoActual = tipos.find(t => t.id === filtros.tipo);
  const tituloSeccion = tipoActual ? `Chicas ${tipoActual.nombre}s` : 'Catálogo de Novias';

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMenuOpen(false);
  };

  // Array de distritos para el selector
  const distritos = ['Todos', ...Object.values(distritosMapping)];

  if (loading) {
    return (
      <div className="App">
        <div className="loading-container" style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          fontSize: '24px',
          color: '#ec4899'
        }}>
          Cargando chicas...
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="App">
        <div className="error-container" style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          gap: '20px'
        }}>
          <div style={{ fontSize: '24px', color: '#ef4444' }}>{error}</div>
          <button 
            onClick={cargarChicas}
            style={{
              padding: '12px 24px',
              background: '#ec4899',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '16px'
            }}
          >
            Reintentar
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      {/* Top Banner */}
      <div className="top-banner">
        <a href="/" className="banner-link">
          <span className="banner-icon">👧</span>
          ¡Reclutando nuevas novias!
        </a>
      </div>

      {/* Header */}
      <header className="header">
        <div className="container">
          <div className="header-content">
            <div className="logo-section">
              <h1 className="main-logo" onClick={() => navigate('/')} style={{cursor: 'pointer'}}>
                <span className="logo-text">Novia de Alquiler</span>
                <span className="logo-brand">"Petit Kano"</span>
                <span className="logo-subtitle">Sitio General</span>
              </h1>
              <p className="locations-text">
                MIRAFLORES / SAN ISIDRO / BARRANCO / SURCO / LINCE / SAN BORJA / MAGDALENA
              </p>
            </div>
          </div>

          <nav className="main-nav">
            <button className={`menu-toggle ${menuOpen ? 'active' : ''}`} onClick={() => setMenuOpen(!menuOpen)}>
              <span></span>
              <span></span>
              <span></span>
            </button>

            <ul className={`nav-menu ${menuOpen ? 'active' : ''}`}>
              <li><a href="/" onClick={(e) => { e.preventDefault(); navigate('/'); }}>Página Principal</a></li>
              <li><a href="#filtros" onClick={(e) => { e.preventDefault(); scrollToSection('filtros'); }}>Filtros</a></li>
              <li><a href="#catalogo" onClick={(e) => { e.preventDefault(); scrollToSection('catalogo'); }}>Catálogo</a></li>
            </ul>
          </nav>
        </div>
      </header>

      {/* Sección de Filtros */}
      <section id="filtros" className="filtros-section">
        <div className="container">
          <div className="filtros-header">
            <h2 className="section-title">{tituloSeccion}</h2>
            <p className="section-description">
              Usa los filtros para encontrar a tu novia ideal
            </p>
          </div>

          <div className="filtros-container">
            {/* Filtro por Tipo */}
            <div className="filtro-grupo">
              <label className="filtro-label">Tipo de Chica</label>
              <select 
                className="filtro-select"
                value={filtros.tipo}
                onChange={(e) => handleFiltroChange('tipo', e.target.value)}
              >
                <option value="todos">Todos los Tipos</option>
                {tipos.map(tipo => (
                  <option key={tipo.id} value={tipo.id}>{tipo.nombre}</option>
                ))}
              </select>
            </div>

            {/* Filtro por Distrito */}
            <div className="filtro-grupo">
              <label className="filtro-label">Distrito</label>
              <select 
                className="filtro-select"
                value={filtros.distrito}
                onChange={(e) => handleFiltroChange('distrito', e.target.value)}
              >
                {distritos.map(distrito => (
                  <option key={distrito} value={distrito}>{distrito}</option>
                ))}
              </select>
            </div>

            {/* Filtro por Edad */}
            <div className="filtro-grupo">
              <label className="filtro-label">Rango de Edad: {filtros.edadMin} - {filtros.edadMax} años</label>
              <div className="filtro-range-container">
                <input 
                  type="range"
                  className="filtro-range"
                  min="18"
                  max="35"
                  value={filtros.edadMin}
                  onChange={(e) => handleFiltroChange('edadMin', parseInt(e.target.value))}
                />
                <input 
                  type="range"
                  className="filtro-range"
                  min="18"
                  max="35"
                  value={filtros.edadMax}
                  onChange={(e) => handleFiltroChange('edadMax', parseInt(e.target.value))}
                />
              </div>
            </div>

            {/* Botón Reset */}
            <div className="filtro-grupo">
              <button className="filtro-reset-btn" onClick={resetFiltros}>
                Limpiar Filtros
              </button>
            </div>
          </div>

          <div className="filtros-resultados">
            <p>Mostrando {chicasFiltradas.length} resultado{chicasFiltradas.length !== 1 ? 's' : ''}</p>
          </div>
        </div>
      </section>

      {/* Sección del Catálogo */}
      <section id="catalogo" className="girls-section">
        <div className="container">
          {chicasFiltradas.length === 0 ? (
            <div className="no-resultados">
              <h3>No se encontraron resultados</h3>
              <p>Intenta ajustar los filtros para ver más opciones</p>
              <button className="filtro-reset-btn" onClick={resetFiltros}>
                Limpiar Filtros
              </button>
            </div>
          ) : (
            <div className="girls-grid">
              {chicasFiltradas.map((chica) => (
                <div 
                  key={chica.id} 
                  className="girl-card"
                  onClick={() => window.open(`/chica/${chica.id}`, '_blank')}
                  style={{cursor: 'pointer'}}
                >
                  <div className="girl-image-wrapper">
                    <img src={chica.imagen} alt={chica.nombre} className="girl-image" />
                    {chica.tags && chica.tags.length > 0 && (
                      <div className="girl-tags">
                        {chica.tags.map((tag, idx) => (
                          <span key={idx} className={`girl-tag ${tag.includes('Ranking') ? 'ranking' : ''}`}>
                            {tag}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>
                  <div className="girl-info">
                    <div className="girl-area">
                      {chica.distritosDisponibles && chica.distritosDisponibles.length > 0 ? (
                        chica.distritosDisponibles.map((distrito, idx) => (
                          <span key={idx}>
                            【{distrito}】
                            {idx < chica.distritosDisponibles.length - 1 ? ' ' : ''}
                          </span>
                        ))
                      ) : (
                        <span>【{chica.distrito}】</span>
                      )}
                    </div>
                    <h3 className="girl-name">{chica.nombre}</h3>
                    <div className="girl-details">
                      <span className="girl-age">{chica.edad} años</span>
                      {chica.tarifaHora && (
                        <span className="girl-tarifa"> • S/{chica.tarifaHora}/hora</span>
                      )}
                    </div>
                    <p className="girl-description">{chica.descripcion}</p>
                    {chica.tipos && chica.tipos.length > 0 && (
                      <div className="girl-tipos">
                        {chica.tipos.map((tipo, idx) => (
                          <span key={idx} className="tipo-badge">
                            {tipos.find(t => t.id === tipo)?.nombre || tipo}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-logo">
              <h3>Novia de Alquiler "Petit Kano"</h3>
              <p>Lima, Perú</p>
            </div>
          </div>

          <div className="back-to-top">
            <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
              Volver arriba ↑
            </button>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default CatalogoPage;









